import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  content: {
    position: "relative",
    textAlign: "center",
    zIndex: 5,
  },

});
